import {attachInputMask} from "../../plugins/inputmask";
let dragula = require('dragula')
import {attachSelect} from "../form/select"
import validateAdditionalQuestionsCount from "./validate-additional-questions-count";
import {validateAnswersCount} from "./validate-additional-questions-answers-count";


$(function () {
    function makeid(length) {
        let result = '';
        const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    function addAnswer($answerList, $answerTemplate, questionId) {
        const randomId = makeid(10);
        const answer = $answerTemplate.html()
            .replaceAll('--QUESTION-ID--', questionId)
            .replaceAll('--ANSWER-ID--', randomId)
        ;

        let $answer = $(answer);
        attachSelect($answer);
        $answerList.append($answer);
    }

    function attachDragAndDrop($context, handleClass) {
        dragula(
            [$context.get(0)],
            {
                moves: function (el, container, handle) {
                    return handle.classList.contains(handleClass);
                }
            }
        );
    }

    function attachQuestionListType(questionType) {
        const $questionType = $(questionType);
        const $minResponses = $questionType.closest('.question-choice').find('.minResponses');
        if ('single' === $questionType.val() || 'dropdown' === $questionType.val() ) {
            $minResponses
                .prop('disabled', true)
                .val('1');
        } else {
            $minResponses.prop('disabled', false)
        }
        validateAnswersCount($questionType.closest('.question-choice'));
    }

    $('.question-list').each(function () {
        attachDragAndDrop($(this), 'handle-question-list');
        $(this).find('.question-type').each(function () {
            attachQuestionListType($(this));
        });
    });

    $('.answer-list').each(function () {
        attachDragAndDrop($(this), 'handle-answer-list');
    })

    $('.question-list')
        .on('click', '.add-next-answer', function () {
            addAnswer(
                $(this).parents('.question-item').find('.answer-list'),
                $(`#${$(this).data('answer-template-id')}`),
                $(this).parents('.question-item').data('question-id')
            );
            validateAnswersCount($(this).closest('.question-choice'));
        })
        .on('change', '.is_answer_limited', function () {
            $(this).parents('.lengthDisabled').find('.answerLength').prop('disabled', !$(this).prop('checked'));
        })
        .on('click', '.answer-remove', function () {
            const $questionChoice = $(this).closest('.question-choice');
            $(this).parents('.answer').remove();
            validateAnswersCount($questionChoice);
        })
        .on('click', '.question-remove', function () {
            $(this).parents('.question-item').remove();
        })
        .on('change', '.question-type', function () {
            attachQuestionListType(this);
        })
    ;


    $('.add-new-question').on('click', function (e) {
        if (!validateAdditionalQuestionsCount($(this))) {
            return;
        }

        const randomId = makeid(10);
        const sourceTemplateId = $(this).data('source-template-id');
        const targetTemplateId = $(this).data('target-id');
        const $list = $(`#${targetTemplateId}`);
        const question = $(`#${sourceTemplateId}`)
            .html()
            .replaceAll('--QUESTION-ID--', randomId);
        const $question = $(question);

        $list.append($question);

        attachDragAndDrop($question.find(".answer-list"), 'handle-answer-list');
        attachInputMask($question);
        attachSelect($question);
    });
    $('.answerLength').each(function() {
        $(this).prop('disabled', !$(this).parents('.lengthDisabled').find('.is_answer_limited').is(':checked'));
    })
});
